export default __webpack_public_path__ + "static/media/korea.4aab19f3.jpg";